module.exports = __webpack_public_path__ + "static/media/icon insta footer-01.bf654ff0.svg";